<template>
  <ul
    class="breadcrumbs flex flex-wrap items-center list-none p-0 m-0 overflow-hidden truncate gap-x-0 gap-y-1"
  >
    <li class="inline-flex items-center gap-2 me-2">
      <fa-icon
        :icon="faLocationArrow"
        class="size-3 shrink-0 self-center"
        aria-hidden
      />
      <nuxt-link
        class="text-mouse hover:text-brand no-underline transition-colors"
        :to="`/${locale}`"
      >
        {{ t('app/home') }}
      </nuxt-link>
      <span class="text-mouse" aria-hidden> / </span>
    </li>

    <li
      v-for="(crumb, index) in crumbs"
      :key="crumb.link"
      class="inline-flex items-center gap-2 me-2"
    >
      <nuxt-link
        v-if="index < crumbs.length - 1"
        class="text-mouse hover:text-brand no-underline transition-colors"
        :to="crumbTo(crumb)"
      >
        {{ crumb.title }}
      </nuxt-link>
      <span v-else class="text-rhino font-bold">{{ crumb.title }}</span>
      <span v-if="index < crumbs.length - 1" class="text-mouse" aria-hidden>
        /
      </span>
    </li>
  </ul>
</template>

<script setup lang="ts">
import { faLocationArrow } from '@fortawesome/pro-solid-svg-icons';
import type { BreadCrumb } from '~/components/common/types';

const { t, locale } = useI18n();

const props = withDefaults(
  defineProps<{
    crumbs: BreadCrumb[];
  }>(),
  {
    crumbs: () => [],
  },
);

// Treat the link as a relative path so a leading slash can't produce a double
// slash after the locale segment.
const crumbTo = (crumb: BreadCrumb): string =>
  `/${locale.value}/${crumb.link.replace(/^\/+/, '')}`;
</script>
